import React, { useContext, useState } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalClose,
  Typography,
  Sheet,
  Textarea,
} from "@mui/joy";
import toast from "react-hot-toast";
import axiosInstance from "../../api/axios";
import AuthContext from "../../contexts/authContext";

export default function CloseReminder({
  openCloseReminder,
  setOpenCloseReminder,
  designId,
}) {
  const [updateText, setUpdateText] = useState("");
  const [nextReminderDate, setNextReminderDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const { setRefresh } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!updateText || updateText.trim() === "") {
      toast.error("All fields are required.");
      return;
    }

    try {
      const res = await axiosInstance.post(`/reminders/close/${designId}`, {
        updateText,
        nextReminderDate,
      });

      if (res.status === 200) {
        toast.success("Reminder closed successfully!");
        setUpdateText("");
        setNextReminderDate("");
        setOpenCloseReminder(false);
        setRefresh(true);
      }
    } catch (err) {
      toast.error("An error occurred while adding the update.");
    }
  };

  return (
    <Modal
      open={openCloseReminder}
      onClose={() => setOpenCloseReminder(false)}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Sheet
        variant="outlined"
        sx={{
          maxWidth: 300,
          width: "100%",
          bgcolor: "#FEDDDD",
          p: 4,
          borderRadius: "md",
          boxShadow: "lg",
        }}
      >
        <ModalClose
          sx={{
            m: 1,
            "& svg": { color: "#800001" },
            "&:hover": {
              backgroundColor: "#800001",
              "& svg": { color: "#fff" },
            },
          }}
          onClick={() => setOpenCloseReminder(false)}
        />

        <Typography
          level="h4"
          sx={{
            color: "#800001",
            fontWeight: "bold",
            mb: 2,
            textAlign: "center",
          }}
        >
          Close Reminder
        </Typography>

        <form onSubmit={handleSubmit}>
          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Next Reminder Date</FormLabel>
            <Input
              name="nextReminderDate"
              value={nextReminderDate}
              type="date"
              onChange={(e) => setNextReminderDate(e.target.value)}
            />
          </FormControl>
          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Update Text</FormLabel>
            <Textarea
              name="updateText"
              value={updateText}
              type="text"
              minRows={4}
              onChange={(e) => setUpdateText(e.target.value)}
              required
            />
          </FormControl>

          <Button
            type="submit"
            fullWidth
            variant="solid"
            sx={{
              mt: 3,
              backgroundColor: "#800001",
              color: "white",
              "&:hover": {
                backgroundColor: "#800001",
                color: "#fff",
              },
            }}
          >
            Submit
          </Button>
        </form>
      </Sheet>
    </Modal>
  );
}
